import { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { CheckmarkIcon } from "../design/icons/CheckmarkIcon";
import { CopyIcon } from "../design/icons/CopyIcon";

/** Copy a value people will otherwise mistype: ids, keys, join commands. */
export default function CopyButton({ value, label = "Copy" }: { value: string; label?: string }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      // Clipboard is blocked outside a secure context; the value is on screen.
      return;
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <Tooltip title={copied ? "Copied" : label}>
      <IconButton size="small" onClick={() => void copy()}>
        {copied ? <CheckmarkIcon fontSize="inherit" color="success" /> : <CopyIcon fontSize="inherit" />}
      </IconButton>
    </Tooltip>
  );
}
